<template>
  <!-- 자동 새로고침 토글 컴포넌트 (ux-patterns.md §11.2, §2) -->
  <div class="refresh-toggle" style="display: inline-flex; align-items: center; gap: 8px;">
    <a-switch
      :checked="enabled"
      size="small"
      @change="$emit('toggle', $event)"
    />
    <span style="font-size: 12px; color: #595959;">
      {{ $t('ecountEtl_common_autoRefresh_toggle') }}
    </span>
    <span v-if="enabled && secondsUntilNext > 0" style="font-size: 11px; color: #8c8c8c;">
      {{ secondsUntilNext }}{{ $t('ecountEtl_common_secondsAfter') }}
    </span>
    <span
      v-if="lastFetchAt"
      style="font-size: 11px; color: #8c8c8c;"
    >
      {{ formatRelativeTime(lastFetchAt) }}
    </span>
    <a-button
      size="small"
      type="text"
      :loading="loading"
      @click="$emit('force-refresh')"
      :title="$t('ecountEtl_common_forceRefresh')"
      style="padding: 0 4px;"
    >
      <reload-outlined />
    </a-button>
  </div>
</template>

<script>
// @MX:SPEC: SPEC-ECOUNT-ETL-OPS-CONSOLE-001 REQ-OC-COMMON-003
import { ReloadOutlined } from '@ant-design/icons-vue';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export default {
  name: 'RefreshToggle',
  components: { ReloadOutlined },
  props: {
    enabled: { type: Boolean, default: true },
    intervalMs: { type: Number, default: 30000 },
    lastFetchAt: { type: Date, default: null },
    loading: { type: Boolean, default: false },
    secondsUntilNext: { type: Number, default: 0 },
  },
  emits: ['toggle', 'force-refresh'],
  methods: {
    formatRelativeTime(date) {
      if (!date) return '';
      return dayjs(date).fromNow();
    },
  },
};
</script>
